var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAutoAssignIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.22691 18.5025C3.70214 18.5025 3.25498 18.3177 2.88541 17.9482C2.51584 17.5786 2.33105 17.1314 2.33105 16.6067V5.05959C2.33105 4.53483 2.51584 4.08766 2.88541 3.71809C3.25498 3.34852 3.70214 3.16374 4.22691 3.16374H5.00045V1.49707H6.7817V3.16374H13.2192V1.49707H15.0005V3.16374H15.774C16.2988 3.16374 16.7459 3.34852 17.1155 3.71809C17.4851 4.08766 17.6698 4.53483 17.6698 5.05959V16.6067C17.6698 17.1314 17.4851 17.5786 17.1155 17.9482C16.7459 18.3177 16.2988 18.5025 15.774 18.5025H4.22691ZM4.22691 16.6067H15.774V8.33313H4.22691V16.6067ZM4.22691 6.66647H15.774V5.05959H4.22691V6.66647Z",
    fill: "#1D5AE8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoAssignIcon);
export default __webpack_public_path__ + "static/media/AutoAssignIcon.d7e4270114d33e5687e15c230cf29dc9.svg";
export { ForwardRef as ReactComponent };